import React, { useState } from "react";
import api from "../lib/api";

const PLATFORMS = ["Instagram", "YouTube", "TikTok", "Facebook", "Podcast", "Conference", "Church", "Other"];

export default function Speaker() {
  const [form, setForm] = useState({
    name: "", email: "", platform: "Instagram", handle: "", audience_size: "",
    topic: "", message: "", preferred_date: "",
  });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [err, setErr] = useState("");

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true); setErr("");
    try {
      await api.post("/speaker/book", form);
      setSent(true);
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Could not send your request.");
    } finally { setSending(false); }
  };

  if (sent) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-32 text-center">
        <div className="font-display text-5xl text-[#2D2A26] tracking-tight">Thank you.</div>
        <p className="text-[#5C5852] mt-6 text-lg leading-relaxed">
          Your request is in. I'll personally review it and respond within a few days.
        </p>
        <div className="mt-10 italic text-[#5C5852]">
          "In all your ways submit to him, and he will make your paths straight."
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <div className="text-xs uppercase tracking-[0.25em] text-[#A36B5E]">Speaker Engagement</div>
      <h1 className="font-display text-5xl text-[#2D2A26] mt-3 tracking-tight">
        Invite me to your space.
      </h1>
      <p className="mt-6 text-lg text-[#5C5852] max-w-xl leading-relaxed">
        Beyond the course, I love meeting people where they are — your podcast, your church,
        your retreat, your creator gathering, your conference, your quiet living-room gathering.
        Whether your community has 5,000 listeners or fifty hearts in a circle, tell me about
        them and the topic that matters to you right now.
      </p>

      <form onSubmit={submit} className="mt-12 bg-white border border-[#EAE5D9] rounded-2xl p-8 sm:p-10 space-y-5">
        <div className="grid sm:grid-cols-2 gap-5">
          <Field label="Your name" name="name" value={form.name} onChange={onChange} required />
          <Field label="Email" name="email" type="email" value={form.email} onChange={onChange} required />
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <label className="text-xs uppercase tracking-widest text-[#5C5852]">Platform / Venue</label>
            <select
              name="platform"
              value={form.platform}
              onChange={onChange}
              data-testid="speaker-platform"
              className="w-full mt-1 px-4 py-3 rounded-xl border border-[#EAE5D9] bg-[#FDFBF7] focus:outline-none focus:border-[#A36B5E]"
            >
              {PLATFORMS.map((p) => <option key={p}>{p}</option>)}
            </select>
          </div>
          <Field label="Handle / Channel (optional)" name="handle" value={form.handle} onChange={onChange} />
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          <Field label="Audience size (optional)" name="audience_size" value={form.audience_size} onChange={onChange} placeholder="e.g. 5k podcast listeners" />
          <Field label="Preferred date (optional)" name="preferred_date" value={form.preferred_date} onChange={onChange} placeholder="e.g. March 2026" />
        </div>

        <Field label="Topic / Theme" name="topic" value={form.topic} onChange={onChange} required placeholder="e.g. Faith for creators, content burnout..." />

        <div>
          <label className="text-xs uppercase tracking-widest text-[#5C5852]">Message</label>
          <textarea
            name="message"
            required
            rows={5}
            value={form.message}
            onChange={onChange}
            data-testid="speaker-message"
            className="w-full mt-1 px-4 py-3 rounded-xl border border-[#EAE5D9] bg-[#FDFBF7] focus:outline-none focus:border-[#A36B5E] resize-none"
            placeholder="Tell me about your community and what you're hoping for..."
          />
        </div>

        {err && <div className="text-sm text-red-600">{err}</div>}

        <button
          type="submit"
          disabled={sending}
          data-testid="speaker-submit"
          className="btn-primary rounded-full px-8 py-3 font-medium disabled:opacity-50"
        >
          {sending ? "Sending..." : "Send request"}
        </button>
      </form>
    </div>
  );
}

function Field({ label, name, value, onChange, type = "text", required, placeholder }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-widest text-[#5C5852]">{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        data-testid={`speaker-${name}`}
        className="w-full mt-1 px-4 py-3 rounded-xl border border-[#EAE5D9] bg-[#FDFBF7] focus:outline-none focus:border-[#A36B5E]"
      />
    </div>
  );
}
